// Lưu token phiên (AgentX /auth) trong localStorage.
const ACCESS = 'agentx.access_token';
const REFRESH = 'agentx.refresh_token';
const USER = 'agentx.user';

export interface StoredUser {
  email: string;
  groups: string[]; // = roles
}

export const tokenStore = {
  get access(): string | null {
    return localStorage.getItem(ACCESS);
  },
  get refresh(): string | null {
    return localStorage.getItem(REFRESH);
  },
  get user(): StoredUser | null {
    const raw = localStorage.getItem(USER);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as StoredUser;
    } catch {
      return null;
    }
  },
  set(access: string, refresh: string | null, user: StoredUser): void {
    localStorage.setItem(ACCESS, access);
    if (refresh) localStorage.setItem(REFRESH, refresh);
    localStorage.setItem(USER, JSON.stringify(user));
  },
  setAccess(access: string): void {
    localStorage.setItem(ACCESS, access);
  },
  clear(): void {
    localStorage.removeItem(ACCESS);
    localStorage.removeItem(REFRESH);
    localStorage.removeItem(USER);
  },
};
